import { COMPONENT_NAME_KEY, SERVICE_NAME_KEY } from '../KeyLabels/commonKeyConstants';
import { COMPONENT_NAME_LABEL, SERVICE_NAME_LABEL } from '../KeyLabels/labelConstants';

export const defaultSelectedItemsForViewByPopOver = [
  { label: COMPONENT_NAME_LABEL, value: COMPONENT_NAME_KEY },
  { label: SERVICE_NAME_LABEL, value: SERVICE_NAME_KEY }
]
